import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: { vesselId : number | undefined } = {
    vesselId: undefined
}

const selectedVesselIdSlice = createSlice({
  name: 'selectedVesselId',
  initialState: initialState,
  reducers: {
    setSelectedVesselId: (state: { vesselId : number | undefined }, action: PayloadAction<number>) => { 
      state.vesselId = action.payload;
    }
  }
});

export const { setSelectedVesselId } = selectedVesselIdSlice.actions;

export default selectedVesselIdSlice.reducer;